<template>
  <div :class="$style.container">
    <div v-if="$store.getters['user/canEdit']" :class="$style.toggleContainer">
      {{ $t('vnc.control') }}
      <toggle-button
        v-if="rfb"
        v-model="control"
        :value="control"
        :sync="true"
      />
    </div>
    <div
      id="screen"
      :class="$style.sreenContainer"
    >
      <div :class="$style.description">
        <div :class="$style.status">
          {{ name }}
        </div>

        <div
          v-if="status === 'connected'"
          :class="[$style.status, $style.green]"
        >
          {{ $t('vnc.connected') }}
        </div>
        <div
          v-if="status === 'disconnected'"
          :class="[$style.status, $style.red]"
        >
          {{ $t('vnc.disabled') }}
        </div>
        <div
          v-if="status === 'error'"
          :class="[$style.status, $style.red]"
        >
          {{ $t('vnc.error') }}
        </div>
        <div
          v-if="status === 'connecting'"
          :class="[$style.status, $style.yellow]"
        >
          {{ $t('vnc.connection') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RFB from '@novnc/novnc';
import jwt from 'jsonwebtoken';
import { getComputersAndVncKey } from '@/api/methods/computers';
import Vue from 'vue';
import { ToggleButton } from 'vue-js-toggle-button';

Vue.component('ToggleButton', ToggleButton);

export default {
  data: () => ({
    name: '',
    status: 'connecting',
    rfb: null,
    host: null,
    port: null,
    sourcePort: null,
    temp: 0,
  }),
  computed: {
    control: {
      get() {
        return !this.rfb.viewOnly;
      },
      set() {
        this.$set(this.rfb, 'viewOnly', !this.rfb.viewOnly);
      },
    },
  },
  async created() {
    this.host = window.location.hostname;
    this.port = window.location.port;
    const { compId } = this.$route.params;
    const res = await getComputersAndVncKey();
    const { targetPort, key } = res;
    this.sourcePort = res.sourcePort;
    const computer = res.result.computers.find((comp) => comp.id === parseInt(compId, 10));
    this.name = computer.nameUser;
    const screen = document.getElementById('screen');

    console.log('Подключение по IP:', computer.ipAddress, computer);

    this.connect(computer.ipAddress, computer, targetPort, key, screen);
  },
  methods: {
    connect(compHost, computer, targetPort, key, screen) {
      let currentHost = compHost;
      let port = targetPort;
      if (compHost.includes(':')) {
        const [vncHost, vncPort] = compHost.split(':');
        currentHost = vncHost;
        port = vncPort;
      }
      const token = jwt.sign({ host: currentHost, port }, key);
      const currentPort = this.port ? `:${this.port}` : '';
      console.log(window.location);
      console.log('port:', this.port);
      console.log('currentPort:', currentPort);
      const url = `${'wss://'}${this.host}${currentPort}/ws/${token}`;

      console.log(url);

      this.rfb = new RFB(screen, url,
        { credentials: { password: computer.vncPass } });

      this.rfb.addEventListener('connect', (e) => {
        if (e) {
          this.status = 'connected';
          console.log('Подключение:', this.temp);
        }
      });

      this.rfb.addEventListener('disconnect', (e) => {
        if (e) {
          if (e.detail.clean) {
            this.status = 'disconnected';
          } else {
            this.status = 'error';
            console.log('Ошибка:', this.temp);
          }
        }
        if (this.status === 'error' && this.temp < 2) {
          console.log('Подключение Error:', this.temp);
          this.status = 'connecting';
          this.temp += 1;

          console.log('Подключение по имени:', computer.nameComputer, computer);
          this.connect(computer.nameComputer, computer, targetPort, key, screen);
        }
      });

      this.rfb.addEventListener('clipboard', async (e) => {
        if (e) {
          await navigator.clipboard.writeText(e.detail.text);
        }
      });

      screen.addEventListener('keydown', async (e) => {
        if (e.code === 'KeyV') {
          const clipboard = await navigator.clipboard.readText();
          this.rfb.clipboardPasteFrom(clipboard);
        }
      }, true);

      this.rfb.viewOnly = true;
      this.rfb.showDotCursor = true;
      this.rfb.resizeSession = true;
      this.rfb.scaleViewport = true;
      this.rfb.clipViewport = true;
    },
  },
};
</script>

<style lang="scss" module>
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: white;
}

::-webkit-scrollbar-thumb {
  background: $branchColor;
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: darkgray;
}

.status {
  text-align: center;
  padding: 5px;

  &.green {
    background: $green;
  }

  &.yellow {
    background: $yellow;
  }

  &.red {
    background: $red;
  }

}

.description {
  border: 1px solid $borderColor;
  border-bottom: 0px;
  display: flex;
  flex-direction: column;
}

.sreenContainer {
  width: 100%;
  height: 100%;
}

.container {
  width: 100%;
  height: 100%;
}

.toggleContainer {
  margin: 20px;
  cursor: default;
  display: flex;
  align-items: center;
  gap: 1%;
}
</style>
